export default __webpack_public_path__ + "static/imgBackgroundTablet-f9f80c2631131fb2545c7d13c892620e.png";